<h5 class="p-3">Fournisseur à réceptionner</h5>

<div class="my-3 p-3 bg-white rounded shadow-sm">
  <div class="input-group mb-4">
    <div class="input-group-prepend">
      <span class="input-group-text"><i class="bi bi-search"></i></span>
    </div>
    <input type="text" class="form-control" placeholder="Recherche" [(ngModel)]="searchRequest.query" (keyup)="querySearch()"/>
  </div>
</div>

<div class="border-bottom"></div>
  
<search-paging [searchComponent]="this"></search-paging>

<div *ngIf="results">
  <table class="table table-hover">
    <tbody>
      <tr *ngFor="let supplier of results.content">
        <td (click)="newRma(supplier)">{{ supplier.name }}</td>
      </tr>
    </tbody>
  </table>
</div>

<search-paging [searchComponent]="this"></search-paging>